export default "__VITE_ASSET__Bh48KBg___"